import clsx from "clsx";
import { FC } from "react";

import { LiveMapRideFilterEnum } from "@ryde/shared";

import { RIDE_FILTER_ICONS } from "../live-map-ride-filter.constants";

interface ILiveMapRideFilterIcon {
  filter: LiveMapRideFilterEnum;
  className?: string;
}

export const LiveMapRideFilterIcon: FC<ILiveMapRideFilterIcon> = ({
  filter,
  className,
}) => {
  const Icon = RIDE_FILTER_ICONS[filter];

  return (
    <Icon
      className={clsx("live-map-ride-filter-icon", className)}
      aria-hidden
    />
  );
};
